// TODO: import modal
import { msgDialogControl } from '@/libs/global';
import ResponseHandlerChain from '@/libs/API/responseHandler';

/**
 * encode URI component.
 * @param {object} - parameters that the URL query string need.
 * @return {string} - encoded query string.
*/
export function createQueryString (data_obj = {}) {
  if (Object.keys(data_obj).length < 1) {
    return '';
  }

  try {
    const queryString = Object.keys(data_obj)
      .map((field) => {
        const value = data_obj[field];

        if (value !== '') {
          return `${field}=${encodeURIComponent(value)}`;
        }
      })
      .join('&');

    return `?${queryString}`;
  } catch (e) {
    alert(e.message);
  }
}

/**
 * execute the corresponding error function when response is error.
 * @param {object} - http error object.
 * @return {boolean}
*/
export function httpErrorHandler (error) {
  const response400 = new ResponseHandlerChain(execError400);
  const response401 = new ResponseHandlerChain(execError401);
  const responseTimeout = new ResponseHandlerChain(captureTimeout);

  response400.setExecutor(response401);
  response401.setExecutor(responseTimeout);

  response400.passRequest(error);
};

const execError400 = ({ response }) => {
  if (response.status !== 400) {
    return false;
  }

  if (response.data.code === '9999') {
    msgDialogControl({
      dialogType: 'alert',
      message: response.data.message
    });
  }
};

const execError401 = ({ response }) => {
  if (response.status !== 401) {
    return false;
  }

  msgDialogControl({
    dialogType: 'alert',
    message: response.data.message
  });
};

const captureTimeout = ({ response }) => {
  if (response.status !== 408 && response.status !== 504) {
    return false;
  }

  msgDialogControl({
    dialogType: 'alert',
    message: '連線逾時'
  });
};
